<template>
    <div class="">
        <div class="header-panel" >
            <div class="container">
        <Breadcrumb 
            :levelTwoText = "'Adventure Cycling Association'"
            
        
        />

        <Heading 
            :heading = "'Adventure Cycling Association'"
            :subheading = "'Stories from the Road and Trail'"
        />
        <!-- <pre>{{route_name}}</pre> -->
        <!-- <ContinentFilter 
            v-on:continent-change="updateSelectedContinent"
        /> -->
        <!-- <pre>{{metadata}}</pre> -->

          

        <div class="">
            <div class="">
                <p>
                   <a href="https://www.adventurecycling.org/" target="_blank">Adventure Cycling</a> has been helping people experience the world by bicycle since 1973 through route development, how-to guidance, an award-winning magazine, community building, and advocating for accessible, safe routes.
                   <br><br>
                   Adventure Cycling's extensive route network includes over 50,000 miles of established routes crisscrossing the United States, 
                   including the iconic <router-link :to="'/routes/TransAmerica'">TransAmerica Trail </router-link> and <router-link :to="'/routes/Great Divide Mountain Bike Route'">Great Divide Mountain Bike Route</router-link>. 
                   Their top-notch maps for each route help riders choose the right experience for them and navigate with confidence.
                   <br><br>
                   With 54,000 members bound together by the joy of bicycle travel, Adventure Cycling is the largest cycling nonprofit working to create a better world for bicycle travel. 
                </p>
            </div>
            <div class="spacer" style="height:30px"></div>
            <TOC v-if="true"
                        :slot1text="'Routes'"
                        :slot1link="'routes'"
                        :slot2text="'Blogs'"
                        :slot2link="'blogs'"
                        :slot3text="'Books'"
                        :slot3link="'books'"
                        />
                
            </div>
            <div class="spacer" style="height:30px"></div>
            </div>
            </div>
<div class="spacer" style="height:30px"></div>
<div class="container">
    <Heading 
            :heading = "'Routes'"
           
            :anchor = "'routes'"
        />
        <RadioFilter 
            v-on:selection-change="updateSelectedTag" 
            :options = "['road', 'gravel', 'long', 'shorter' ]"
            :type = "'route-tags'"
            :label = "'Style'"
        />
        <div class="spacer" style="height:50px"></div>


        <div v-if="routesData.length > 0">
            <ul >
                <li  class="list-link" v-for="routeObj in sortedRoutes" v-bind:key="routeObj.display_name">
                    <RouteRow v-if="passesFilter(routeObj)"
                        v-bind:routeObj = "routeObj"
                       
                    />
                </li>
            </ul>
        </div>

        

        <div class="spacer" style="height:50px"></div>      
        <div class="container is-size-5 is-size-6-mobile">For the full list, including routes that don't yet have travel journal entries on BikeSleepBike, visit the 
            <a href="https://www.adventurecycling.org/routes-and-maps/adventure-cycling-route-network/interactive-network-map/" target="_blank">Adventure Cycling route collection.</a></div>
       <div class="spacer" style="height:60px"></div>  
        <div class="divider"></div>
    <div class="section card" ref="results" v-if="isLoading">
        <b-icon class="fas fa-spinner fa-spin"></b-icon>
        Loading...
    </div>
   
    
    <div class="spacer" style="height:50px"></div>
    
        <Heading v-if="!isLoading"
            :heading = "'Blog Posts'"
            :subheading = "''"
            :anchor = "'blogs'"
        />
        
        <div class="spacer" style="height:50px"></div>
        <!-- <pre>{{postsByRoute}}</pre> -->


        <div 
         v-for="(route, idx) in routesData"
         v-bind:key = route.display_name
         >
         
            <h3 class="is-size-3 is-size-4-mobile title">{{route.display_name}}</h3>
            <div class="spacer" style="height:30px"></div>
            <div v-if="postsByRoute && postsByRoute[route.display_name]">
                <div class="columns is-multiline is-variable is-4-desktop" >
                    <PageResultColumns  
                        v-for="(page, idx) in postsByRoute[route.display_name].slice(0,3)"
                        v-bind:key = idx 
                        :page = "page"
                        :approveMode = "false"
                        :showYear="true"
                    />
                </div>
                <div class="spacer" style="height:30px"></div>
                <router-link v-if="postsByRoute[route.display_name].length > 3" :to="'/routes/' + $keyify(route.display_name)" class='button is-info is-medium'>More Posts</router-link>
            </div>
            <div class="spacer" style="height:80px"></div>
            <div class="divider" v-if="idx != routesData.length - 1"></div>
            <div class="spacer" style="height:80px" v-if="idx != routesData.length - 1"></div>
        </div>


         <div class="spacer" style="height:20px"></div>

    <b-button v-if="routesData.length > 0" v-scroll-to="'#app'" class="is-large">Scroll to top</b-button>

    <div class="spacer" style="height:80px"></div>
    <div class="divider"></div>
  <div class="spacer" style="height:60px"></div>
    
    <BooksList v-if="!isLoading " 
        :anchor="'books'"
        :booksArray = "ACABooks"
        :heading = "'Books'"
        :subheading = "'Featuring Adventure Cycling Routes'"

        :num = "12"
        :isMinimal = "true"
    />
    <div class="spacer" style="height:80px"></div>
    <div style="background-color:rgba(185, 238, 255, 0.37);"> 
        <div class="spacer" style="height:5px"></div>
        <SocialSharePrompt :headerText="'Desert Bike Travel - BikeSleepBike'" :location="'bottom'" :label="'Share This Collection'" :labelColor="'black'"/>
        <div class="spacer" style="height:50px"></div>
    </div>

    <!-- <div class="spacer" style="height:80px"></div> -->
    <!-- <div class="divider"></div> -->
    <div class="spacer" style="height:60px"></div>
    <div class='container'>
        <p class="is-size-5">Do you write about your own bike adventures?</p><br>
        <router-link to="/share" class="button is-size-5 is-size-5-mobile is-info" style="margin-top:10px;">Submit Your Blog</router-link>
    </div>
    <div class="spacer" style="height:100px"></div>
</div>
    </div>
</template>

<script>
import PageResultColumns from '@/components/PageResultColumns';
// import PageResult from '@/components/PageResult';
// import ContinentFilter from '@/components/ContinentFilter';
import Heading from '@/components/Heading';
import RouteRow from '@/components/RouteRow';
import Intro from '@/components/Intro';
import Breadcrumb from '@/components/Breadcrumb';
// import Book from '@/components/Book';
import BooksList from '@/components/BooksList';
import TOC from '@/components/TOC';
import RadioFilter from '@/components/RadioFilter';
import SocialSharePrompt from '@/components/SocialSharePrompt';

export default {
  name: 'AdventureCycling',
  components: {PageResultColumns, Heading, RouteRow, Intro, Breadcrumb, BooksList, RadioFilter, TOC, SocialSharePrompt},
  
  props: ['route', 'post_count'],
  data () {
    return {
        routesData: [],
        orderby: 'posts',
        isLoading: false,

        // route_name: this.$unkeyify(this.route),
        // metadata: "",
        // isLoading: false,
        noMorePages: false,
        lastVisibleResult: undefined,
        currentQuery: undefined,
        queryLimit: 21,
        resultPages: [],
        sortedResultPages: [],
        postsByRoute: {},
        ACABooks: [],
        selectedRouteFilter: 'All'
        // booksByRoute: [],
        // postCount: ''

       
    }
  },
  watch: {
      "routesData"(newRoutes) {
        //   this.postsByRoute = {};
          for (var i = 0; i < this.routesData.length; i++) {
            //   console.log("fetching posts for " + newRoutes[i].display_name);
              this.fetchPages("routes", "array-contains", this.routesData[i].display_name);
              this.fetchBooksByRoute(this.routesData[i].display_name);
          }
        //   console.log(this.resultPages);
      },
      "resultPages"(resultPages) {
          var tempArray = resultPages;
           for (var i = tempArray.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = tempArray[i];
                tempArray[i] = tempArray[j];
                tempArray[j] = temp;
            }
            this.sortedResultPages = tempArray;
      },
      
    //   "$route.params.route"(newroute) {
    //       this.route_name = this.$unkeyify(newroute);
    //     this.fetchPages("routes", "array-contains", this.route_name);
    // // console.log("Getting ");
    //     this.$fetchDoc("routes", this.$keyify(this.route_name), 'metadata'); 

    //     this.fetchBooksByRoute(this.route_name);
    //     },
  },
  computed: {
    sortedRoutes() {
        if (this.orderby == 'posts') {
            return [...this.routesData].sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
        } else {
            return [...this.routesData].sort((a, b) => (a.display_name > b.display_name) ? 1 : -1);
        }
    }
  },
  methods: {
     updateSelectedTag(tag) {
         this.selectedRouteFilter = tag;
     },
     passesFilter(routeObj) {
         if (this.selectedRouteFilter == 'All') {return true; }
         else if (this.selectedRouteFilter == 'road' && routeObj.road) { return true; }
         else if (this.selectedRouteFilter == 'gravel' && routeObj.gravel) { return true; }
         else if (this.selectedRouteFilter == 'long' && routeObj['length'].split(' ')[0] > 1000) { return true; }
         else if (this.selectedRouteFilter == 'shorter' && routeObj['length'].split(' ')[0] < 1000) { return true; }
         else { return false; }
     },
      getRoutes() {
        console.log("Getting route data");
        this.routesData = [];
        // var result = [];
        var that = this;
        var pageCountData = {};
        var routesMetadata = [];
        this.isLoading = true;
        // first get routes page counts
        this.$db.collection("page_counts").doc('routes').get()
        .then(function(doc) {
            if (doc.exists) {
                var temp = {};
                temp[doc.id] = doc.data();
                pageCountData = temp.routes;
                // then get routes metadata
                var that2 = that;
                var tempRoutesData = [];
                that.$db.collection("routes").where("developer", "==", "ACA").get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        routesMetadata.push(doc.data());
                    });

                    // then merge the two
                    for (var i = 0; i < routesMetadata.length; i++) {
                        var displayName = routesMetadata[i].display_name;
                        if (displayName in pageCountData) {
                            var newobj = routesMetadata[i];
                            newobj.post_count = pageCountData[displayName].post_count;
                            tempRoutesData.push(newobj);
                        } else {
                            var newobj = routesMetadata[i];
                            newobj.post_count = 0;
                            tempRoutesData.push(newobj);
                        }
                    }
                    // console.log(that.routesData);
                    that.routesData = tempRoutesData;
                    // that.fetchPages("routes", "array-contains", displayName );
                    that.routesData.sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
                    that.isLoading = false;

                });
            } else {
                console.log("ERROR: Can't fetch links by type", that.type);
                that.isLoading = false;
            }

        })
        .catch(function(error) {
            console.log("Error getting links by type: ", error);
            that.isLoading = false;
        });
        

    },

     fetchPages(fieldname, querytype, value) {
            if (this.$debug) {console.log("DEBUG: In function fetchPages");}
            if (value != "") { // GET FILTERED
                this.$analytics.logEvent('fetch_results', { type: 'style', value: value});
                this.isLoading = true;
                var that = this;
                var result = [];
                this.noMorePages = false;
                this.lastVisibleResult = undefined;
                this.currentQuery = this.$db.collection("pages").where(fieldname, querytype, value).orderBy("year", "desc").orderBy("added", "desc");
                this.currentQuery.limit(that.queryLimit).get()
                    .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            var dataAndId = doc.data();
                            dataAndId['id'] = doc.id;
                            result.push(dataAndId);
                        
                        });
                        that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                        if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                            that.noMorePages = true;
                        }
                        // console.log(result);
                        // that.postsByRoute[value] = result;
                        that.resultPages = [...that.resultPages, ...result];
                        
                        that.$set(that.postsByRoute, value, result);
                        
                        
                        
                        that.isLoading = false;
                        // console.log("latest posts by route");
                        // console.log(that.postsByRoute);
                    })
                    .catch(function(error) {
                        console.log("Error getting pages by style: ", error);
                        that.isLoading = false;
                    });
                    
            } 
            
        },

        
       
        fetchBooksByRoute(route) {
            if (this.$debug) {console.log("DEBUG: In function fetchPagesByRoute");}
            // var books = [];
        // if (value != "") { // GET FILTERED
            this.$analytics.logEvent('fetch_results', { type: 'books by route', value: route});
            var that = this;
            var result = [];
           
            this.$db.collection("books").where('routes', 'array-contains', route).orderBy("title", "asc").limit(8).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                        that.ACABooks.push(dataAndId);
                    
                    });
                   
                    // books = result;
                    // that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting books by route: ", error);
                    // that.isLoading = false;
                });
        // } 
        },
        getBooks() {
            for (var i = 0; i < this.routesData.length; i++) {
                this.fetchBooksByRoute(routesData[i].display_name);
            }
        }
      
    

  },
  metaInfo() {
        var title =  'Adventure Cycling Association Routes';
        var description = "Adventure Cycling Association Routes";
        return {
            title: title,
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },
  mounted() {
    // this.route_name = this.$route.params.route;
    // console.log("UNKEYIFYIED:", this.route_name);
    
    this.getRoutes();
    // this.getBooks();
    // this.fetchBooksByRoute(this.route_name);
    // this.getCount(this.route_name);
     
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  

</style>

<style>
    .page-results {
        max-width: 1500px;
        margin-left: auto;
        margin-right: auto;
    }
  
</style>


// WEBPACK FOOTER //
// src/components/FeatureACA.vue